import React from 'react';
import ActionButtons from '../shared/ActionButtons';

const DistributionTab = ({
  platforms,
  handleCheck,
  checkAll,
  error,
  handleAddRelease,
  isSubmitting,
  successBtn
}) => {
  return (
    <div className="row">
      <div className="col-12 mt-3">
        <div className="table-responsive">
          <table className="table dash-table">
            <thead>
              <tr>
                <td>
                  <div className="d-flex align-items-center">
                    <div className='dash-form-check'>
                      <input 
                        type="checkbox" 
                        className='form-check-input me-3' 
                        onChange={checkAll}
                      />
                    </div>
                    Platform
                  </div>
                </td>
                <td>Description</td>
              </tr>
            </thead>
            <tbody>
              {platforms.map((platform, i) => (
                <tr key={i}>
                  <td>
                    <div className="table-item d-flex align-items-center">
                      <div className='dash-form-check'>
                        <input 
                          type="checkbox" 
                          className='form-check-input' 
                          checked={platform.checked}
                          onChange={() => handleCheck(i)}
                        />
                      </div>
                      <img className='platform-img' src={platform.logo} alt="" />
                      <h6 className='ms-2'>{platform.title}</h6>
                    </div>
                  </td>
                  <td><div className='table-item'>{platform.description}</div></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      
      {error !== '' && (
        <div className="col-12 mt-3">
          <h6 className='text-danger text-center' dangerouslySetInnerHTML={{ __html: error }}></h6>
        </div>
      )}
      
      <div className="col-12 mt-3">
        <ActionButtons
          onSubmit={handleAddRelease}
          isSubmitting={isSubmitting}
        />
        <button ref={successBtn} data-bs-toggle="modal" data-bs-target="#successModal" hidden></button>
      </div>
    </div>
  );
};

export default DistributionTab; 